'use client';

import { useFormContext, Controller } from 'react-hook-form';
import { ClearableInput } from '@/shared/ui/kit/clearable-input';
import { EmailFormData } from '@/shared/lib/validation/registration-wizard/email';


export const EmailField = () => {
    const { control } = useFormContext<EmailFormData>();

    return (
        <Controller
            control={ control }
            name="email"
            render={ ({ field, fieldState }) => (
                <ClearableInput
                    label="E-mail:"
                    placeholder="mail@example.com"
                    autoComplete="email"
                    type="email"
                    required
                    name={ field.name }
                    value={ field.value ?? '' }
                    onChange={ field.onChange }
                    onBlur={ field.onBlur }
                    error={ fieldState.error?.message }
                    onClear={ () => field.onChange('') }
                />
            ) }
        />
    );
};
